import React from "react";
import { Delete } from "lucide-react";

interface PackersNumpadProps {
  filter: string;
  onFilterChange: (filter: string) => void;
}

const PackersNumpad = ({ filter, onFilterChange }: PackersNumpadProps) => {
  const handleDigit = (digit: string) => {
    if (filter.length < 2) {
      onFilterChange(filter + digit);
    }
  };

  const handleClear = () => onFilterChange("");

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {["1","2","3","4","5","6","7","8","9","0"].map((d) => (
        <button
          key={d}
          onClick={() => handleDigit(d)}
          className="w-10 h-10 rounded-lg bg-white/10 text-white font-bold text-lg hover:bg-white/20 active:bg-white/30 transition-colors"
        >
          {d}
        </button>
      ))}
      <button
        onClick={handleClear}
        className="w-10 h-10 rounded-lg bg-white/10 text-white hover:bg-white/20 active:bg-white/30 transition-colors flex items-center justify-center"
      >
        <Delete className="w-5 h-5" />
      </button>
      {filter && (
        <span className="text-white/70 text-sm ml-2">
          Filter: ...{filter}
        </span>
      )}
    </div>
  );
};

export default PackersNumpad;
